<template>
  <div id="app">
    <navigation
      :sections="sections"
      :active="active"
      :visited="visited"
    ></navigation>
    <full-page ref="fullpage" id="fullpage" :options="options">
      <div
        v-for="(section, index) in sections"
        :key="section.id"
        v-bind:class="['section', section.id]"
        v-bind:ref="section.id"
      >
      <component
        :class="sectionClasses(index)"
        :active="section.id === active"
        :is="section.componentName"
        :width="pageWidth"
        :height="pageHeight"
        @prizeModal="openModal($event)"
        @sectionHeightChange="rebuildPage()">
      </component>
      </div>
    </full-page>
    <scroll-down :active="active" :delay="0"/>

    <modal v-show="modalOpen">
      <template v-slot:body>
        <global-modals v-bind:which-modal="modalId"></global-modals>
      </template>
    </modal>
    <loader v-show="loaderOpen" />

  </div>
</template>

<script>
import Vue from 'vue'
import store from './store'
import 'fullpage.js/vendors/scrolloverflow'
import DetectBrowser from 'browser-detect'

import Navigation from './components/navigation/Navigation.vue'
import ScrollDown from './components/scroll-down/ScrollDown.vue'
import Loader from './components/Loader.vue'
import Modal from './components/Modal.vue'
import GlobalModals from './components/GlobalModals.vue'

import Home from './pages/Home.vue'
import Benefits from './pages/Benefits.vue'
import Difference from './pages/Difference.vue'
import Tips from './pages/Tips.vue'
import Find from './pages/Find.vue'
import Win from './pages/Win.vue'

import sections from './data.json'

// Global components
Vue.component('home-page', Home)
Vue.component('benefits-page', Benefits)
Vue.component('difference-page', Difference)
Vue.component('tips-page', Tips)
Vue.component('find-page', Find)
Vue.component('win-page', Win)

export default {
  name: 'app',
  components: {
    navigation: Navigation,
    'scroll-down': ScrollDown,
    'loader': Loader,
    'modal': Modal,
    'global-modals': GlobalModals
  },
  data() {
    return {
      initialized: false,
      visited: [],
      active: sections[0].id,
      sections: sections,
      available: sections,
      pageWidth: 0,
      pageHeight: 0,
      options: {
        scrollOverflow: false,
        verticalCentered: true,
        autoScrolling: false,
        fitToSection: false,
        scrollBar: false,
        normalScrollElements: '#rules-container, #stateDropdownList, #win, #winEntry, #WinForm, #WinThanks, #WinEmailEntry',
        normalScrollElementTouchThreshold: 10,
        responsiveWidth: 992,
        menu: '#menu',
        anchors: sections.map(d => d.id),
        onLeave: this.activateSlide,
        afterLoad: this.slideEnter,
        afterResize: this.resize,
        licenseKey:  '26E169D3-82F7484A-A72CD104-91D215DA'
      }
    }
  },
  computed: {
    activeIndex() {
      return sections.findIndex((c) => c.id === this.active)
    },
    loaderOpen() {
      return store.state.showLoader
    },
    modalOpen() {
      return store.state.modalOpen
    },
    modalId() {
      return store.state.modalId
    }
  },
  mounted() {
    // Add a class to the body indicating the current browser.
    // This gives us the ability to apply browser specific styles (but try to avoid).
    let browser = DetectBrowser()
    document.body.classList.add(browser.name)
  },
  methods: {
    rebuildPage() {
      const _this = this
      setTimeout(function(){
        _this.$refs.fullpage.api.reBuild()
        store.commit('endTransition')
        
        // The code below is to keep the Win section 
        // scrolled to the top when changing states.
        _this.$refs.fullpage.api.silentMoveTo('find')
        _this.$refs.fullpage.api.silentMoveTo('win')
      }, 500)
    },
    sectionClasses(index) {
      return index === this.activeIndex
        ? 'active'
        : index < this.activeIndex
          ? 'above'
          : 'below'
    },
    activateSlide(current, next) {
      this.active = next.anchor
      const v = []
      for (let i = 0; i < sections.length; i++) {
        const id = sections[i].id
        v.push(id)
        if (id === this.active) {
          break
        }
      }
      if (v.length > this.visited.length) {
        this.visited = v
      }
    },
    slideEnter(last, current) {
      if (!this.initialized) {
        this.initialized = true
        this.activateSlide(current, current)
      }
    },
    resize(width, height) {
      this.pageWidth = width
      this.pageHeight = height
    }
  }
}
</script>

<style lang="scss">
/** App **/
@import "./theme";
@import "./main";

.grecaptcha-badge { visibility: hidden; }
body,
#app {
  display: flex;
  background-color: $white;
}

#app {
  font-family: "Ainslie-NorMed", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: zespri-foreground(default);
}

#fullpage {
  @include media-breakpoint-up(lg) {
    padding-left: $nav-width;
  }
}

.section {
  .benefits {

    @include media-breakpoint-up(lg) {
      margin: 0 !important;
    }
  }
}
</style>
